import {parseNumber, formatNumber} from 'libphonenumber-js'

function parsePhone(phone = '', iso) {
    if (!iso) {
        let parse_phone = parseNumber(phone);
        if (parse_phone.country) {
            iso = parse_phone.country.toLowerCase();
            phone = parse_phone.phone;
        }
    }
    iso = iso || 'ru';
    let international = formatNumber(phone, iso.toUpperCase(), 'International');

    return international ? international : phone;
}

export {parsePhone};